import blueEmailIcon from "assets/icons/blueEmailIcon.svg";
import blueLockIcon from "assets/icons/blueLockIcon.svg";
import eyeIcon from "assets/icons/eye.svg";
import userIcon from "assets/icons/user.svg";
import { CustomButton } from "components/component-styles/buttons/index.styled";
import { FormContainer } from "components/component-styles/alignment";
import FormikControl from "components/form/formikControl";
import RootLayout from "components/layout/rootLayout";
import { UserInfoContext } from "contexts/userInfo";
import { Form, Formik } from "formik";
import useWindowDimensions from "hooks/useWindowDimensions";
import { useContext } from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Users from "services/apis/usersAPI";
import * as Yup from "yup";
import {
  ButtonContainer,
  Container,
  EditContainer,
  ExitContainer,
  FormRow,
  FormWrapper,
} from "./index.styled";

export default function EditAccount() {
  const userData = useContext(UserInfoContext);

  const userProfile = userData?.usersInfo?.profile;
  const initialValues = {
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    defaultAiModel: "test",
  };

  const validationSchema = Yup.object({
    oldPassword: Yup.string().required("رمز عبور الزامی می‌باشد"),
    newPassword: Yup.string().required("رمز جدید الزامی می باشد"),
    confirmPassword: Yup.string().oneOf(
      [Yup.ref("newPassword"), ""],
      "Passwords must match"
    ),
  });

  const validationSchemaII = Yup.object({
    email: Yup.string().email("فرمت ایمیل نادرست است."),
    firstName: Yup.string(),
    lastName: Yup.string(),
  });

  const onSubmit = async (values, { resetForm }) => {
    const reqObj = {
      oldPassword: values.oldPassword,
      newPassword: values.newPassword,
    };

    const response = await new Users(reqObj).patchChangePassword();

    if (response.type) {
      toast.success("رمز شما با موفقیت تغییر یافت.");
      resetForm();
    } else {
      toast.error(response.message);
    }
  };

  // edit profile handler
  const onSubmitHandler = async (values, { resetForm }) => {
    const reqObj = validateEditedInputs(values);

    if (Object.keys(reqObj).length < 2) {
      toast.warning("ابتدا فیلد های مورد نظر خود را ویرایش کنید.");
    } else {
      const response = await new Users(reqObj).putEditUsers();
      if (response.type) {
        toast.success("اطلاعات کاربری شما با موفقیت تغییر یافت.");
        // resetForm();
      } else {
        toast.error(response.message);
      }
    }
  };

  function validateEditedInputs(values) {
    const reqObj = {};

    for (const [key, value] of Object.entries(values)) {
      if (value) {
        reqObj[key] = value;
      }
    }

    return reqObj;
  }

  const dim = useWindowDimensions();
  const Navigate = useNavigate();
  //exit handler
  const ExitHandler = () => {
    Navigate("/login");
    localStorage.clear();
  };

  return (
    <>
      <Helmet>
        <title>ویرایش پروفایل</title>
      </Helmet>

      <RootLayout>
        <EditContainer>
          <Container>
            <div className="title">
              <h2>ویرایش حساب</h2>
            </div>
            <FormWrapper>
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchemaII}
                onSubmit={onSubmitHandler}
              >
                {(formik) => {
                  return (
                    <FormContainer>
                      <Form>
                        <FormRow>
                          <FormikControl
                            control="input"
                            name="firstName"
                            type="text"
                            label="نام کاربر"
                            rightIcon={userIcon}
                            enableReinitialize={true}
                            width360="296px"
                            height="51px"
                            width="328px"
                            width417="328px"
                            placeholderColor="#2D3134"
                            // defaultValue={userProfile?.firstName}
                            placeholder={userProfile?.firstName ?? "نام کاربر"}
                            // value={userProfile?.firstName}
                          />
                          <FormikControl
                            control="input"
                            name="lastName"
                            height="51px"
                            // defaultValue={userProfile?.lastName}
                            type="text"
                            label="نام خانوادگی کاربر"
                            placeholder={
                              userProfile?.lastName ?? "نام خانوادگی کاربر"
                            }
                            rightIcon={userIcon}
                            width360="296px"
                            width="328px"
                            width417="328px"
                            placeholderColor="#2D3134"
                          />

                          <FormikControl
                            control="input"
                            name="email"
                            label=" ایمیل"
                            height="51px"
                            // defaultValue={userProfile?.email}
                            placeholder={userProfile?.email ?? "ایمیل"}
                            rightIcon={blueEmailIcon}
                            width360="296px"
                            width="328px"
                            width417="328px"
                            placeholderColor="#2D3134"
                          />
                        </FormRow>
                        <ButtonContainer>
                          <CustomButton
                            type="submit"
                            background="#6CAEFF"
                            borderColor="#6CAEFF"
                          >
                            ذخیره
                          </CustomButton>
                        </ButtonContainer>
                      </Form>
                    </FormContainer>
                  );
                }}
              </Formik>
            </FormWrapper>
          </Container>
          <Container>
            <div className="title">
              <h2>تغییر گذرواژه</h2>
            </div>

            <FormWrapper>
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
              >
                {(formik) => {
                  return (
                    <FormContainer>
                      <Form>
                        <FormRow>
                          <FormikControl
                            control="input"
                            name="oldPassword"
                            type="password"
                            label="گذرواژه فعلی"
                            placeholder="رمز عبور فعلی"
                            toggleType={true}
                            width360="296px"
                            width="328px"
                            width417="328px"
                            rightIcon={blueLockIcon}
                            placeholderColor="#2D3134"
                            leftIcon={eyeIcon}
                          />
                          <FormikControl
                            control="input"
                            name="newPassword"
                            type="password"
                            label="گذرواژه جدید"
                            placeholder="رمز عبور جدید"
                            rightIcon={blueLockIcon}
                            // leftIcon={EyeIcon}
                            toggleType={true}
                            width360="296px"
                            width="328px"
                            width417="328px"
                            placeholderColor="#2D3134"
                            leftIcon={eyeIcon}
                          />

                          <FormikControl
                            control="input"
                            name="confirmPassword"
                            label="تکرار گذرواژه جدید"
                            type="password"
                            placeholder="تکرار رمز عبور جدید"
                            rightIcon={blueLockIcon}
                            toggleType={true}
                            width360="296px"
                            width="328px"
                            width417="328px"
                            placeholderColor="#2D3134"
                            leftIcon={eyeIcon}
                          />
                        </FormRow>
                        <ButtonContainer>
                          <CustomButton
                            type="submit"
                            background="#6CAEFF"
                            borderColor="#6CAEFF"
                            backgroundHover="#FFF"
                            colorHover="#6CAEFF"
                            borderColorHover="#6CAEFF"
                          >
                            ذخیره
                          </CustomButton>
                        </ButtonContainer>
                      </Form>
                    </FormContainer>
                  );
                }}
              </Formik>
            </FormWrapper>
          </Container>
          {dim.width < 1024 ? (
            <ExitContainer>
              <button onClick={ExitHandler}>خروج</button>
            </ExitContainer>
          ) : (
            ""
          )}
        </EditContainer>
      </RootLayout>
    </>
  );
}
